<template>
  <div>
    <v-btn
      color="primary"
      class="mb-2 ml-5"
      @click="isShowSelectAuthFixDialog = true"
      :disabled="disabledManyDoneAuthFix"
    >
      批次完工授權工單
    </v-btn>
    <v-dialog persistent v-model="isShowSelectAuthFixDialog" fullscreen>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="isLoadingManyDoneAuthFix || selectedAuthFixDoneList.length === 0"
            @click="isShowDoneReasonDialog = true"
          >
            完工原因
          </v-btn>
          <image-upload-dialog
            ref="imageUploadDialog"
            :btnDisabled="isLoadingManyDoneAuthFix || selectedAuthFixDoneList.length === 0"
            :isLoading="isLoadingUploadManyFixImage"
            @uploadPhotos="uploadPhotos"
          />
        </v-card-title>
        <v-dialog persistent v-model="isShowDoneReasonDialog" max-width="800">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
              <ValidationObserver ref="dialogDoneReason">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      :name="$t('fix_done_reason')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        outlined
                        v-model="doneReason"
                        :error-messages="errors[0]"
                        :disabled="isLoadingUpdateManyDoneReason"
                      >
                        <template v-slot:label>
                          <span class="red--text">
                            <strong>* </strong>
                          </span>
                          {{ $t('fix_done_reason') }}
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                text
                @click="closeDoneReasonDialog"
                :disabled="isLoadingUpdateManyDoneReason"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="success"
                text
                @click="updateManyDoneReason"
                :loading="isLoadingUpdateManyDoneReason"
              >
                {{ $t('common_confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
          :headers="fixDataTableHeaders"
          :items="selectedAuthFixList"
          class="elevation-1 ma-5"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          item-key="Number"
          show-select
          v-model="selectedAuthFixDoneList"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>授權工單清單</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.FixType`]="{ item }">
            {{ turnFixType(item) }}
          </template>
          <template v-slot:[`item.FileCount`]="{ item }">
            <v-chip
              color="primary"
              v-if="item.FileNameList && item.FileNameList.length !== 0"
              @click="isShowPhotoDialogBtn(item)"
            >
              {{ item.FileNameList.length }}
            </v-chip>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <v-dialog persistent v-if="isShowPhotoDialog" v-model="isShowPhotoDialog" fullscreen>
          <v-card>
            <photo-gallery :editedFix="editedFix" @searchFix="updateSelectedAuthFix" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closePhotoDialog">
                {{ $t('common_close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="closeSelectAuthFixDialog"
            :disabled="isLoadingManyDoneAuthFix"
          >
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn
            color="success"
            text
            @click="checkThrowPhoto"
            :disabled="disabledThrow"
            :loading="isLoadingManyDoneAuthFix"
          >
            轉拋
          </v-btn>
          <info-dialog
            :isShowDialog="isShowCheckDonePhoto"
            :message="infoMessage"
            @closeDialog="closeInfoDialog"
            @confirmDialog="throwManyAuthorizeToResume"
          ></info-dialog>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { FixType } from '@/js/FixType'
import { HttpFix } from '@/js/http-Manager'
import ImageUploadDialog from '@/components/Fix/ImageUploadDialog.vue'
import PhotoGallery from '@/components/PhotoGallery.vue'
import InfoDialog from '@/components/InfoDialog.vue'
export default {
  components: { ImageUploadDialog, PhotoGallery, InfoDialog },
  props: {
    selectedAuthFixList: {
      type: Array,
      default: () => []
    }
  },
  name: 'SelectAuthFixDone',
  data: () => ({
    fixType: FixType,
    isShowSelectAuthFixDialog: false,
    selectedAuthFixDoneList: [],
    isLoadingManyDoneAuthFix: false,
    isShowDoneReasonDialog: false,
    isLoadingUpdateManyDoneReason: false,
    doneReason: '',
    isLoadingUploadManyFixImage: false,
    isShowPhotoDialog: false,
    editedFix: {},
    isShowCheckDonePhoto: false,
    infoMessage: ''
  }),
  mounted () {},
  watch: {},
  computed: {
    disabledManyDoneAuthFix () {
      return (
        this.selectedAuthFixList.length === 0 ||
        this.selectedAuthFixList.findIndex(
          (x) =>
            (x.FixType !== this.fixType.AuthorizeInstall &&
              x.FixType !== this.fixType.AuthorizeRemove) ||
            x.IsDone
        ) !== -1
      )
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    fixDataTableHeaders () {
      return [
        {
          text: this.$t('fix_type'),
          align: 'start',
          value: 'FixType',
          sortable: false
        },
        {
          text: this.$t('installation_notice_number'),
          align: 'start',
          value: 'Number'
        },
        {
          text: this.$t('fix_subject'),
          align: 'start',
          value: 'Subject'
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName',
          sortable: false
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName',
          sortable: false
        },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('fix_done'),
          align: 'center',
          value: 'IsDone',
          sortable: false
        },
        {
          text: '完工原因',
          align: 'start',
          value: 'DoneReason'
        },
        {
          text: '檔案',
          align: 'start',
          value: 'FileCount'
        }
      ]
    },
    disabledThrow () {
      return this.selectedAuthFixList.findIndex((x) => !x.DoneReason) !== -1
    }
  },
  methods: {
    turnFixType (val) {
      return FixType.FixTypeName(val.FixType)
    },
    async checkThrowPhoto () {
      let array = []
      this.selectedAuthFixList.forEach((element) => {
        if (!element.FileNameList || element.FileNameList.length === 0) {
          array.push(element)
        }
      })
      if (array.length > 0) {
        this.isShowCheckDonePhoto = true
        this.infoMessage = array.map((x) => x.Number).join(',') + ' 以上工單無照片，確定要完工?'
      } else {
        await this.throwManyAuthorizeToResume()
      }
    },
    async throwManyAuthorizeToResume () {
      this.isLoadingManyDoneAuthFix = true
      let response = await HttpFix.ThrowManyToResume(this.selectedAuthFixList)
      this.isLoadingManyDoneAuthFix = false
      if (response && response.status === 200) {
        this.closeSelectAuthFixDialog()
      }
    },
    closeInfoDialog () {
      this.isShowCheckDonePhoto = false
      this.infoMessage = ''
    },
    closeSelectAuthFixDialog () {
      this.selectedAuthFixDoneList = []
      this.$emit('cleanSelectedAuthFixList')
      this.isShowSelectAuthFixDialog = false
    },
    closeDoneReasonDialog () {
      this.isShowDoneReasonDialog = false
      this.doneReason = ''
      this.$refs.dialogDoneReason.reset()
    },
    async updateManyDoneReason () {
      const isValid = await this.$refs.dialogDoneReason.validate()
      if (!isValid) return

      // 取得選中項目的ID清單
      const selectedIds = this.selectedAuthFixDoneList.map((item) => item.Id)

      let updateData = {
        FixIdList: selectedIds,
        DoneReason: this.doneReason
      }
      this.isLoadingUpdateManyDoneReason = true
      let response = await HttpFix.UpdateManyDoneReason(updateData)
      this.isLoadingUpdateManyDoneReason = false

      if (response && response.status === 200) {
        this.selectedAuthFixDoneList = response.data.Data
        this.$emit('updateSelectedAuthFixList', this.selectedAuthFixDoneList)
        this.closeDoneReasonDialog()
      }
    },
    async uploadPhotos (images) {
      if (images.length > 0) {
        let formData = new FormData()

        images.forEach((element) => {
          formData.append('Files', element.file)
        })
        this.selectedAuthFixDoneList.forEach((element) => {
          formData.append('NumberList', element.Number)
        })

        this.isLoadingUploadManyFixImage = true
        let response = await HttpFix.UploadManyFixImage(formData)

        if (response && response.status === 200) {
          this.selectedAuthFixDoneList.forEach((element) => {
            if (!element.FileNameList) {
              element.FileNameList = []
            }
            images.forEach((image) => {
              if (element.FileNameList.findIndex((x) => x === image.name) === -1) {
                element.FileNameList.push(image.name)
              }
            })
          })
          let responseUpdateManyFix = await HttpFix.UpdateManyFix(this.selectedAuthFixDoneList)
          if (responseUpdateManyFix && responseUpdateManyFix.status === 200) {
            this.selectedAuthFixDoneList = responseUpdateManyFix.data.Data
            this.$emit('updateSelectedAuthFixList', this.selectedAuthFixDoneList)
          }
        }
        this.isLoadingUploadManyFixImage = false
        this.$refs.imageUploadDialog.closeUploadFileDialog()
      }
    },
    isShowPhotoDialogBtn (item) {
      this.editedFix = JSON.parse(JSON.stringify(item))
      this.isShowPhotoDialog = true
    },
    closePhotoDialog () {
      this.isShowPhotoDialog = false
    },
    async updateSelectedAuthFix (val) {
      this.$emit('updateSelectedAuthFix', val)
    }
  }
}
</script>
